let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iKW3a")).then(() => parcelRequire('fUdDx'));